'use strict';

/**
 * Bootstrap configuration for bootstrap-sass-loader
 *
 * Scripts are disabled to not load jQuery.
 * If you depend on Bootstrap scripts consider react-bootstrap instead.
 * https://github.com/react-bootstrap/react-bootstrap
 *
 * In order to keep the bundle size low in production
 * disable components you don't use.
 *
 */

module.exports = {
  preBootstrapCustomizations: './src/theme/variables.scss',
  mainSass: './src/theme/bootstrap.overrides.scss',
  verbose: false,
  debug: false,
  scripts: {
    transition: false,
    alert: false,
    button: false,
    carousel: false,
    collapse: false,
    dropdown: false,
    modal: false,
    tooltip: false,
    popover: false,
    scrollspy: false,
    tab: false,
    affix: false
  },
  styles: {
    mixins: true,
    normalize: true,
    print: true,
    glyphicons: true,
    scaffolding: true,
    type: true,
    code: true,
    grid: true,
    tables: false,
    forms: true,
    buttons: true,
    'component-animations': true,
    dropdowns: true,
    'button-groups': true,
    'input-groups': false,
    navs: true,
    navbar: true,
    breadcrumbs: false,
    pagination: true,
    pager: true,
    labels: true,
    badges: false,
    jumbotron: true,
    thumbnails: true,
    alerts: true,
    'progress-bars': false,
    media: false,
    'list-group': true,
    panels: true,
    wells: false,
    'responsive-embed': true,
    close: true,
    modals: true,
    tooltip: false,
    popovers: true,
    carousel: false,
    utilities: true,
    'responsive-utilities': true
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/theme/bootstrap.config.js
// module id = 2427
// module chunks = 0